"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balloon = void 0;
const NoteType_1 = require("../lib/NoteType");
const CountableDrumrollNote_1 = require("../lib/CountableDrumrollNote");
/**
 * Balloon note that needs to reach a certain amount of hits to be popped.
 * Represented by `7`.
 */
class Balloon extends CountableDrumrollNote_1.CountableDrumrollNote {
    constructor() {
        super(NoteType_1.NoteType.Balloon);
    }
}
exports.Balloon = Balloon;
